import { useEffect, useRef } from "react";
import type { NarrativeEntry } from "../types/game";

interface Props {
  entries: NarrativeEntry[];
  isStreaming: boolean;
}

export function CommPanel({ entries, isStreaming }: Props) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Defer scroll to after DOM paint so scrollHeight is accurate
    requestAnimationFrame(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    });
  }, [entries]);

  return (
    <div className="comm-panel" ref={scrollRef}>
      {entries.map((entry) => (
        <div key={entry.id} className={`comm-entry comm-${entry.type}`}>
          {entry.type === "dialogue" && (
            <div className={`dialogue-line dialogue-${entry.role} ${entry.sidebar ? "dialogue-sidebar" : ""}`}>
              <span className="dialogue-speaker">{entry.speaker}</span>
              <span className="dialogue-text">{entry.text}</span>
            </div>
          )}
          {entry.type === "player" && (
            <div className="player-action">
              <span className="player-label">CAPTAIN</span>
              <span className="player-text">{entry.text}</span>
            </div>
          )}
          {entry.type === "system" && (
            <div className="system-message">{entry.text}</div>
          )}
        </div>
      ))}
      {isStreaming && (
        <div className="comm-entry comm-streaming">
          <span className="streaming-indicator" />
        </div>
      )}
    </div>
  );
}
